"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./Label.module.css"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Label = (function (_super) {
    __extends(Label, _super);
    function Label(props) {
        var _this = _super.call(this, props) || this;
        _this.helpVisible = false;
        return _this;
    }
    Label.prototype.render = function () {
        var _a = this.props, error = _a.error, help = _a.help, text = _a.text, required = _a.required, htmlFor = _a.htmlFor, className = _a.className, classNameWrap = _a.classNameWrap;
        return (React.createElement("div", { className: classNameWrap },
            React.createElement("label", { className: className ? className : styles.root, htmlFor: htmlFor },
                text,
                required && React.createElement("span", null, "*"),
                help && React.createElement("small", { style: { display: "block" } }, help)),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    __decorate([
        mobx_1.observable
    ], Label.prototype, "helpVisible", void 0);
    Label = __decorate([
        mobx_react_1.observer
    ], Label);
    return Label;
}(react_1.Component));
exports.Label = Label;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGFiZWwuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0xhYmVsL0xhYmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDJDQUE4QjtBQUM5QiwrQkFBK0I7QUFDL0IseURBQTRDO0FBQzVDLHlDQUFtQztBQUNuQyw2QkFBK0I7QUFhL0I7SUFBMkIseUJBQXlCO0lBSWhELGVBQVksS0FBSztRQUFqQixZQUNJLGtCQUFNLEtBQUssQ0FBQyxTQUNmO1FBSk8saUJBQVcsR0FBRyxLQUFLLENBQUE7O0lBSTNCLENBQUM7SUFDTSxzQkFBTSxHQUFiO1FBQ1UsSUFBQSxLQUFtRSxJQUFJLENBQUMsS0FBSyxFQUE1RSxLQUFLLFdBQUEsRUFBRSxJQUFJLFVBQUEsRUFBRSxJQUFJLFVBQUEsRUFBRSxRQUFRLGNBQUEsRUFBRSxPQUFPLGFBQUEsRUFBRSxTQUFTLGVBQUEsRUFBRSxhQUFhLG1CQUFjLENBQUE7UUFFbkYsT0FBTyxDQUNILDZCQUFLLFNBQVMsRUFBRSxhQUFhO1lBQ3pCLCtCQUFPLFNBQVMsRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTztnQkFDbEUsSUFBSTtnQkFDSixRQUFRLElBQUksc0NBQWM7Z0JBQzFCLElBQUksSUFBSSwrQkFBTyxLQUFLLEVBQUUsRUFBQyxPQUFPLEVBQUUsT0FBTyxFQUFDLElBQUcsSUFBSSxDQUFTLENBQ3JEO1lBQ1AsS0FBSyxJQUFJLDJCQUFHLFNBQVMsRUFBRSxNQUFNLENBQUMsS0FBSztnQkFBRyxLQUFLO29CQUFNLENBQ2hELENBQ1QsQ0FBQTtJQUNMLENBQUM7SUFsQkQ7UUFEQyxpQkFBVTs4Q0FDZ0I7SUFGbEIsS0FBSztRQURqQixxQkFBUTtPQUNJLEtBQUssQ0FxQmpCO0lBQUQsWUFBQztDQUFBLEFBckJELENBQTJCLGlCQUFTLEdBcUJuQztBQXJCWSxzQkFBSyJ9